export default {
  fromServer: data => ({
    uid: data.uid,
    name: data.name,
    type: data.type,
    fileType: data.file_type,
    srcName: data.src_name,
    projectUid: data.project_uid,
    createdAt: data.created_at,
    createdBy: data.created_by,
    updatedAt: data.updated_at,
    updatedBy: data.updated_by,
    versions: data.versions,
  }),
};
